
import { getFileAsset } from '@sanity/asset-utils'

import sanityConfig from '../../../studio/sanity.json'

export function videoAssetFor (source) {
  return getFileAsset(source, sanityConfig.api)
}
